import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import MasterLayout from '../../../Components/Common/MasterLayout';
import { MastersCategoriesConfig } from './MastersConfig';

const Masters = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Administración', icon: 'icon-settings' }
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Maestros' links={breadcrumbLinks} icon='icon-database' />
					<MasterLayout moduleTitle="Maestros" categories={MastersCategoriesConfig} />
				</Container>
			</div>
		</React.Fragment>
	);
};

export default Masters;
